import { ref, watch } from 'vue';
import { defineStore } from 'pinia';
import { resizeWindow } from '@/services/WindowStateService';
import { storeToRefs } from 'pinia';
import { useMessagesStore } from './useMessagesStore';

export const useWindowStateStore = defineStore('windowState', () => {

  const chatWindowOpen = ref(false);
  const hasChatWindowOpened = ref(false);
  const startersVisible = ref(false);
  const textUsButtonVisible = ref(true);
  const showContactForm = ref(false);
  
  const messagesStore = useMessagesStore();
  const { lastMessage } = storeToRefs(messagesStore);

  function initializeStarters() {
    resizeWindow('closed');
    setTimeout(() => {
      watch(
        lastMessage,
        (newLastMessage) => {
          if (newLastMessage?.role === 'assistant' && !chatWindowOpen.value) {
            showChatStarters();
          }
        },
        { deep: true, immediate: true }
      );
      if (!chatWindowOpen.value) {
        showChatStarters();
      }
    }, 3500);
  }

  function openChatWindow() {
    startersVisible.value = false;
    resizeWindow('open');
    setTimeout(() => {
      chatWindowOpen.value = true;
      hasChatWindowOpened.value = true;
      startersVisible.value = false;
      textUsButtonVisible.value = false;
    }, 100);
  }

  function closeChatWindow() {
    chatWindowOpen.value = false;
    textUsButtonVisible.value = true;
    showContactForm.value = false;
    resizeWindow('closed');
  }

  function toggleChatWindow() {
    if (chatWindowOpen.value) {
      closeChatWindow();
    } else {
      openChatWindow();
    }
  }

  function showChatStarters() {
    resizeWindow('starters');
    setTimeout(() => {
      chatWindowOpen.value = false;
      startersVisible.value = true;
    }, 100);
  }

  function hideChatStarters() {
    startersVisible.value = false;
    chatWindowOpen.value = false;
    resizeWindow('closed');
  }

  return {
    chatWindowOpen,
    hasChatWindowOpened,
    startersVisible,
    textUsButtonVisible,
    toggleChatWindow,
    showChatStarters,
    hideChatStarters,
    initializeStarters,
    showContactForm,
  }
})
